import { createIconComponent } from '../../factory/create-icon-component';
export const ShallowIcon = createIconComponent(
  'ShallowIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.25 19H3.75M9 7.5L11.5 5M11.5 5V15M11.5 5L14 7.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
